import { useMonitorEngineContext } from '@nibfe/mcp-monitor-sdk';
import { useRequest } from './useRequest';
import { API_PATH } from '../types/shared';
import { getRequestBaseParams } from '../utils/request';
export function useQueryPopupCache(options) {
    const ctx = useMonitorEngineContext();
    const commonParams = ctx._runtimeInfo?.commonParams;
    const { request: queryPopupCache } = useRequest(API_PATH.QUERY_POPUP_CACHE);
    /**
     * 查询弹窗频控
     * @param cacheKeyExpireMap 弹窗缓存Key与过期时间的映射，如 { 'guestSuccessPopup': 86400 }
     * @returns hitMap: key为弹窗标识，value为true表示命中频控（已展示过，不应弹出）
     */
    async function checkPopupCache(onlyRead, cacheKeyExpireMap) {
        try {
            const feCommonParams = await getRequestBaseParams(commonParams);
            const params = {
                ...feCommonParams,
                onlyRead,
                activityId: options.activityId,
                cacheKeyExpireMap
            };
            const res = await queryPopupCache(params);
            if (!res) {
                return null;
            }
            return res.hitMap ?? {};
        }
        catch (error) {
            ctx._raptorReport.monitorReportBizFailed?.({
                apiPath: API_PATH.QUERY_POPUP_CACHE
            });
            ctx._raptorReport.monitorReportLog?.('queryPopupCache', error, {
                level: 'error',
                category: 'ajaxError'
            });
            return null;
        }
    }
    return {
        checkPopupCache
    };
}
